
export default function UAEMapSection() {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Strategically Located in the UAE
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Based in Ajman, we leverage the UAE's strategic position as a global trading hub, 
            with easy access to major ports and international shipping routes.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* UAE Map */}
          <div className="relative">
            <div className="bg-gradient-to-br from-red-50 to-green-50 rounded-2xl p-8 shadow-lg">
              {/* UAE Flag */}
              <div className="flex justify-center mb-6">
                <div className="w-24 h-16 border border-gray-300 rounded shadow-md overflow-hidden relative">
                  <div className="absolute left-0 top-0 w-8 h-16 bg-red-500"></div>
                  <div className="h-1/3 bg-green-500"></div>
                  <div className="h-1/3 bg-white"></div>
                  <div className="h-1/3 bg-black"></div>
                </div>
              </div>
              
              <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
                United Arab Emirates
              </h3>
              
              {/* Interactive UAE Map with Ajman highlighted */}
              <div className="relative w-full max-w-md mx-auto">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d115681.22!2d55.5136!3d25.4052!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ef5f43c29d3d4f7%3A0x7c73c8f9c7d4e8a9!2sAjman%2C%20United%20Arab%20Emirates!5e0!3m2!1sen!2s!4v1234567890123!5m2!1sen!2s"
                  width="100%"
                  height="300"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  className="rounded-lg shadow-md"
                ></iframe>
              </div>

              {/* Key Cities with Ajman highlighted */}
              <div className="mt-8 grid grid-cols-3 gap-4">
                <div className="text-center p-4 bg-white rounded-lg shadow-sm">
                  <div className="w-3 h-3 bg-red-600 rounded-full mx-auto mb-2"></div>
                  <h4 className="font-semibold text-gray-900">Abu Dhabi</h4>
                  <p className="text-sm text-gray-600">Capital City</p>
                </div>
                <div className="text-center p-4 bg-white rounded-lg shadow-sm">
                  <div className="w-3 h-3 bg-red-600 rounded-full mx-auto mb-2"></div>
                  <h4 className="font-semibold text-gray-900">Dubai</h4>
                  <p className="text-sm text-gray-600">Business Hub</p>
                </div>
                <div className="text-center p-4 bg-gradient-to-br from-red-600 to-red-700 text-white rounded-lg shadow-lg border-2 border-red-500">
                  <div className="w-4 h-4 bg-white rounded-full mx-auto mb-2 animate-pulse"></div>
                  <h4 className="font-bold text-lg">Ajman</h4>
                  <p className="text-sm opacity-90 font-medium">Our Location</p>
                  <div className="mt-2">
                    <i className="ri-map-pin-fill text-white text-lg"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Location Benefits */}
          <div className="space-y-8">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                Why Choose UAE as Your Trading Partner?
              </h3>
            </div>

            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-global-line text-red-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-semibold text-gray-900 mb-2">
                    Strategic Global Position
                  </h4>
                  <p className="text-gray-600">
                    Located at the crossroads of Europe, Asia, and Africa, providing optimal access to global markets.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-ship-line text-green-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-semibold text-gray-900 mb-2">
                    World-Class Ports
                  </h4>
                  <p className="text-gray-600">
                    Access to Jebel Ali Port and other major shipping facilities for efficient global distribution.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-plane-line text-blue-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-semibold text-gray-900 mb-2">
                    International Connectivity
                  </h4>
                  <p className="text-gray-600">
                    Direct flights and shipping routes to over 240 destinations worldwide from UAE.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-check-line text-yellow-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-semibold text-gray-900 mb-2">
                    Business-Friendly Environment
                  </h4>
                  <p className="text-gray-600">
                    Stable economy, modern infrastructure, and supportive government policies for international trade.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
